import EFPicture from '@elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

let maskScene: any = null;
export default function W() {
    const { useLang, useEffect, useState, Link } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [gap, setGap] = useState(24);

    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        const resizeAni = () => {
            if (maskScene) AniContainer.removeScene(maskScene);

            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);
            maskScene = AniContainer.create({
                triggerElement: '.dpu-detail-W',
                triggerHook: 1,
                offset: startH,
                duration: 1200, //window.innerHeight * 2,
                onEnter: () => {
                    setTextEnter(true);
                },
                //onLeave: () => setTextEnter(false),
            });
        };
        resizeAni();
    }, []);

    const cards: any[] = [
        {
            img: '/responsive/picture/common-products/Trolley.png',
            name: t('secW_card1_name'),
            link: t('secW_card1_link'),
        },
        {
            img: '/responsive/picture/common-products/Amp_Hub_50.png',
            name: t('secW_card2_name'),
            link: t('secW_card2_link'),
        },
        {
            img: '/responsive/picture/common-products/EV_XStream_Adapter.png',
            name: t('secW_card3_name'),
            link: t('secW_card3_link'),
        },
        {
            img: '/responsive/picture/common-products/AC_Generator_Charging_Adapter.png',
            name: t('secW_card4_name'),
            link: t('secW_card4_link'),
        },
        {
            img: '/responsive/picture/common-products/Dongle_PPS_4G.png',
            name: t('secW_card5_name'),
            link: t('secW_card5_link'),
        },
        {
            img: '/responsive/picture/common-products/PowerInsight.png',
            name: t('secW_card6_name'),
            link: t('secW_card6_link'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => setGap(window?.innerWidth >= 1440 ? 24 : window?.innerWidth >= 768 ? 20 : 12);
            resize();
            //window?.addEventListener('resize', resize);
            //return () => window.removeEventListener('resize', resize);
        }
    }, []);

    return (
        <section className={`dpu-detail-W dpu-detail-section ${textEnter ? 'textEnter' : ''} ${css['dpu-detail-W']}`}>
            <EfSpec />
            <h2 className="title">{t('secW_title')}</h2>
            <Swiper className="cards swiper-box" modules={[Navigation]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} navigation={true}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.name} />
                        </div>
                        <p className={`card-name`}>{card?.name}</p>
                        <Link
                            className="card-link"
                            href={card?.link}
                            target={card?.link.startsWith('http') ? '_blank' : '_self'}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: card?.name,
                                position: 'Product Detail_Accessories ',
                            }}
                        >
                            {t('common_learn_more')}
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
            <EfSpec />
        </section>
    );
}
